import { baseURL } from "../ApiConstant";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";

// get all instalment.
export const getAllInstalmentService = async () => {
  try {
    const response = await apiClient.get(`/api/payment-instalment`);
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

//create instalment
export const createInstalmentService = async (
  project_id: number,
  invoice_no: string,
  amount: number,
  invoice_date: string,
  due_date: string,
  status: string,
  generated_invoice: string | null
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();
    formData.append("project_id", String(project_id));
    formData.append("invoice_no", invoice_no);
    formData.append("amount", String(amount));
    formData.append("invoice_date", invoice_date);
    formData.append("due_date", due_date);
    formData.append("status", status);

    if (generated_invoice) {
      formData.append("generated_invoice", generated_invoice);
    }

    const response = await fetch(
      `${baseURL}/api/payment-instalment/create`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: formData,
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//update instalment
export const updateInstalmentService = async (
  id: number,
  invoice_no: string,
  amount: number,
  invoice_date: string,
  due_date: string,
  project_id: number,
  generated_invoice: string | null,
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();

    formData.append("invoice_no", invoice_no);
    formData.append("amount", String(amount));
    formData.append("invoice_date", invoice_date);
    formData.append("due_date", due_date);
    formData.append("project_id", String(project_id));

    if (generated_invoice) {
      formData.append("generated_invoice", generated_invoice);
    }
    const response = await fetch(
      `${baseURL}/api/payment-instalment/update/${id}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: formData,
      }
    );
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deleteInstalmentService = async (id: number): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem('token');
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/payment-instalment/delete/${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': FULL_TOKEN
      },
    });

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Invoice status changing
export const invoiceStatusChangeService = async (
  invoice_id: number,
  status: string
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/payment-instalment/status-changed/${invoice_id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({ status }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

interface InvoiceGenerateApiResponse {
  status: boolean;
  statusCode?: number;
  massage?: string;
  error?: string;
  errors?: any[];
  errorInfo?: any[];
  data?: string | null;
}

// Invoice generate
export const invoiceGenerateService = async (
  project_id: number,
  invoice_no: string,
  amount: number,
  invoice_date: string,
  due_date: string,
  status: string
): Promise<InvoiceGenerateApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();

    formData.append("project_id", String(project_id));
    formData.append("invoice_no", invoice_no);
    formData.append("amount", String(amount));
    formData.append("invoice_date", invoice_date);
    formData.append("due_date", due_date);
    formData.append("status", status);

    const response = await fetch(
      `${baseURL}/api/payment-invice/make`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: formData,
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data["data"]
      };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};